<script>
  import { createEventDispatcher } from "svelte";

  export let copy;
  export let exitButton;

  const dispatch = createEventDispatcher();

  function closeLegal() {
    dispatch("close-modal", false);
    log2('3dclick', 'legals closed');
    loggin('3dclick', 'legals closed');
  }
</script>

<style type="text/scss">
  .legal-container {
    width: 100%;
    height: 100%;
    position: fixed;
    display: flex;
    z-index: 40;
    justify-content: center;
    color: #ffffff;
    align-items: center;

    .legal {
      padding: 1.5rem 0;
      width: 100%;
      height: 100%;
      // max-width: 1200px;
      background: linear-gradient(
        90deg,
        rgba(14, 14, 14, 1) 0%,
        rgba(69, 69, 69, 1) 100%
      );
      text-align: left;
      display: flex;
    }

    .text-container {
      width: 100%;
      // align-self: center;
      margin:  3rem;
      font-size: 0.8rem;
    }
    .close-container {
      width: 100%;
      // max-width: 1200px;
      position: absolute;

      .exit {
        float: right;
      width: 2.5rem;
      margin: 2.5rem;
      cursor: pointer;
      }
    }
  }
</style>

<div class="legal-container">
  <div class="legal">
    <div class="close-container">
      <div class="exit" on:click={closeLegal}>
        <img class="img" src={exitButton} alt="exit" />
      </div>
    </div>
    <div class="text-container">
      {@html copy}
    </div>
  </div>
</div>
